import Nav from "./nav"
import HeaderGalaxySites from "./header_galaxy_sites"
import Home from "./home"
import TableOfContentsNav from "./table-of-contents-nav"
import ContactForm from "./contact-form"
import CookiesPanel from "./cookies-panel"
import HCalendar from "./h-calendar"

if ( document.querySelector('.page-template-template-home') !== null ) {
	document.addEventListener("DOMContentLoaded", function () {
        Nav(jQuery)
        HeaderGalaxySites(jQuery)
        Home(jQuery)
        TableOfContentsNav(jQuery)
        ContactForm(jQuery)
        CookiesPanel(jQuery)
	})
} else {
	document.addEventListener("DOMContentLoaded", function () {
                Nav(jQuery)
                HeaderGalaxySites(jQuery)
                TableOfContentsNav(jQuery)
                ContactForm(jQuery)
                CookiesPanel(jQuery)
                HCalendar(jQuery)
	})
}
